import SEO, { Breadcrumb as _Breadcrumb } from './seo.container'

export type Breadcrumb = _Breadcrumb

export default SEO
